import React, { useEffect, useState } from 'react'
import Header from '../../../components/generals/header'
import stylesIndex from './../../../css/Index.module.css'
import store from '../../../reducer/store'
import styles from '../../../css/reports/Reports.module.css'
import { NavLink, useNavigate } from 'react-router-dom'
import { Button } from 'reactstrap'
import DataTableDemo from '../../../components/generals/datatables/datatable'
import { getData } from '../../../actions/servicesHttp'
import { formatDate } from '../../../components/generals/charts/utils/DatesFormats'
import { useTranslation } from 'react-i18next'
import Loading from '../../../components/generals/loading'

export default function GeofencesReport () {
  const { t, ready } = useTranslation('geofencesReport')
  const { user } = store.getState()
  const role = user.roles
  const navigate = useNavigate()
  const [urlGeofences] = useState('geofences')
  const [geofencesReport, setGeofencesReport] = useState(null)

  const columns = [
    { field: 'name', header: t('headers.one') },
    { field: 'description', header: t('headers.two') },
    { field: 'type', header: t('headers.three') },
    { field: 'place', header: t('headers.four') },
    { field: 'date_order', header: t('headers.five') },
    { field: 'area', header: t('headers.six') }
  ]

  const getGeofence = async (url, set) => {
    const response = await getData(url, undefined, navigate)
    if (response?.status === 200) {
      const geofences = response.data

      geofences.forEach((element) => {
        element.date_order = formatDate(element.date_order)
      })
      set(geofences)
    } else {
      set([])
    }
  }

  useEffect(() => {
    if (ready) {
      getGeofence(urlGeofences, setGeofencesReport)
    }
  }, [ready])

  return (
    <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
      <div className={`content  ${stylesIndex.mainContent}`}>
        <Header title={t('title')} />
        <div>
          <NavLink to="/mdm/reports">
              <Button variant="dark" className={styles.return_btn}>
                <i className="pi pi-arrow-circle-left" style={{ marginRight: '0.5rem' }}></i>
                {t('button')}
              </Button>
          </NavLink>
        </div>
        <div className={styles.div_dt}>
          {geofencesReport === null && <Loading color="primary" />}
            {geofencesReport !== null && <DataTableDemo
                data={geofencesReport}
                table="geofencesReport"
                onSelecteds={null}
                reload={null}
                rowSelecteds={false}
                rowStates={false}
                editUsers={false}
                actionDashboard={false}
                optionsMenu={null}
                informationOptionMenu={null}
                exportsPdf={role?.reportsPage.exportPdfInReport}
                exportsCsv={role?.reportsPage.exportCsvInReport}
                actionDelete={false}
                showMenu={null}
                getFence={null}
                editOptionMenu={false}
                searchs={['name', 'description', 'type', 'place', 'date_order']}
                columns={columns}
                namePdf={t('namePdf')}
            />}
        </div>
      </div>
    </div>
  )
}
